'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'starship-freighter';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e03a';
var svgPathData = 'M377.1 371.9L315.5 285c2.9-9.2 4.5-18.9 4.5-29 0-53-43-96-96-96s-96 43-96 96 43 96 96 96c.6 0 1.1 0 1.7 0l60.7 85.7c-19.6 6.7-40.5 10.4-62.4 10.4-106 0-192-86-192-192S118 64 224 64c104.4 0 189.3 83.3 191.9 187 .1 3.2 .1 6.7 0 10.2-1.1 41.5-15.4 79.8-38.9 110.7zM405.4 400l-8.5 0-.6-.9c22.5-27.1 38.7-59.5 46.5-95.1l101.2 0 0 42.1-138.6 53.9zm74.6 5.3l96-37.3 0-96-128.6 0c.8-10.6 .7-21.4 0-31.8l0-.2 128.6 0 0-96-228.4-88.8C308.2 39.9 266.3 32 224 32 100.3 32 0 132.3 0 256S100.3 480 224 480c28.7 0 57.1-3.6 84.8-10.7 8.5 12 18.6 26.2 30.2 42.7l141 0 0-106.7zM447.4 208l-4.6 0c-8.4-38.6-26.8-73.5-52.3-101.8l153.4 59.7 0 42.1-96.6 0zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM348.2 469.6L262.3 344.1c15-6.5 28-16.8 37.9-29.6l80.5 117.6 67.3 0 0 48-92.7 0-7.1-10.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarshipFreighter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;